import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-65">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-66">
        <div className="invisible md:hidden" data-id="element-67">
          <div className="h-10" data-id="element-68"></div>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8 ml-auto" data-id="element-69">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-aspira-navy hover:text-aspira-green transition-colors font-medium" data-id="element-70">
              {link.name}
            </a>)}
          <a href="#contact" className="bg-aspira-green hover:bg-opacity-90 text-white px-5 py-2 rounded-md transition-colors font-medium" data-id="element-71">
            Get Started
          </a>
        </nav>
        {/* Mobile Navigation Toggle */}
        <button className="md:hidden text-aspira-navy ml-auto" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-72">
          {isMenuOpen ? <XIcon size={24} data-id="element-73" /> : <MenuIcon size={24} data-id="element-74" />}
        </button>
      </div>
      {/* Mobile Navigation Menu */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg" data-id="element-75">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-76">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-aspira-navy hover:text-aspira-green transition-colors font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-77">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-aspira-green hover:bg-opacity-90 text-white px-5 py-2 rounded-md transition-colors font-medium text-center" onClick={() => setIsMenuOpen(false)} data-id="element-78">
              Get Started
            </a>
          </div>
        </div>}
    </header>;
};